import React/*, { Component }*/ from "react";
import hasStorage from "../hoc/hasStorage";
import Loading from "../components/Loading";
import { deepClone } from '../helpers';
//import moment from 'moment';
import Auth from "../lib/Auth";

export const AppContext = React.createContext();

//const auth = new Auth();

class AppContextProvider extends React.Component {
    auth;
    constructor(props) {

        super(props);

        // 3 step process to initiating state:
        // - first, go with the initial values
        // - second, override those initial values with whatever has been retained in session storage
        // - finally, reset loading properly back to 0. 
        //      why? it's because if the user had reloaded the screen in the middle of a call to the hasData HOC's getData() function,
        //      then the loading property of AppContext will always be stuck at a non-zero value. This is because the getData() function
        //      will never have a chance to complete.
        this.state = {
            ...this.initialState,
            ...this.props.getFromSessionStorage("contextState"),
            ...{ loading: 0 }
        };

        this.auth = new Auth();
        this.auth.syncFunc = this.syncFunc;

    }

    get initialState() {

        //console.log("hi")
        return {
            //auth: auth,
            accessToken: "",
            // list of dealerships underneath this one
            childDealerships: [],
            currencyCode: "",
            currencySymbol: "",
            date: "",
            dateId: "",
            email: "",
            expiresAt: null, // the number of milliseconds since epoch (Jan 1, 1970) until the time when the session expires

            hasParent: false, // does the org that that the user belongs to have at least one parent?

            idToken: "",
            isNavBarVisible: null, // a boolean value, but initially null
            languageCode: "",
            uiLanguage: "en",
            setLanguage: this.setLanguage,

            loading: 0, // a counter of the number of api calls that we're currently waiting for

            // months for last two years
            monthsLast2Years: null,

            // navbar links
            navLinks: [],

            // orgID and orgName of the org that the user belongs to
            orgCode: "",
            orgID: "",
            orgName: "",
            orgType: "", // the org types found in SOM.OrgType, minus the Root org type

            // holds information about the user, e.g. email, name, profile picture
            profile: null,

            // list of report groups
            reportGroups: [],

            // the user's roles. (a user can have multiple)
            roles: [],

            // save selections from inventory shaping rules page
            inventoryShapingSelectedOrg: null,
            inventoryShapingSelectedReportGroup: null,
            inventoryShapingSelectedOrgType: '',

            // save selections from the dashboard
            selectedFilterDate: "",
            selectedFilterType: "viewAll", // "dealership" or "reportGroup" or "viewAll"
            selectedFilterReportGroup: null, // object of shape {reportGroupID: 123, reportGroupName: "Report group name"}
            selectedFilterOrg: null, // object of shape {orgID: 123, orgName: "org name"}
            selectedFilterVendor: null, // object of shape {orgVendorID: 123, vendorName: "blah"}

            // save suggested order type
            selectedOrderType: 0, // 0 (all), 1 (GM), 2 (P&A)

            selectedPartNumber: null,

            // save selections from the reports
            //selectedReportDateRange: null, // object of shape {start: "Tue Dec 04 2018 00:00:00 GMT-0800 (Pacific Standard Time)", end: null}
            selectedReportStartDate: null,
            selectedReportEndDate: null,
            selectedReportOrg: null, // object of shape {orgID: 123, orgName: "org name"}
            selectedReportOrgType: null, // "dealership" or "reportGroup"
            selectedReportReportGroup: null, // object of shape {reportGroupID: 123, reportGroupName: "Report group name"}
            selectedReportVendor: null, // object of shape {id: "orgvendorid", label: "vendorname"}
            selectedReportPartGroup: null, // "P&A" or "GM"
            selectedReportPartCategory: null, // object of shape {partCategoryID: 123, partCategoryName: "category name"}
            selectedReportMinCost: 0, // decimal cost
            selectedReportMaxCost: 0, // ^
            selectedReportMinValue: 0, //decimal total report value minimum
            selectedReportMaxValue: 0, //decimal total report value minimum
            selectedReportAge: 0, //int, months since last sale 
            subjectClaim: '',

            userName: "",
            userID: "",
            currentBookingID: null,
        }
    };

    // componentDidMount() {
    //     // this would get fired if we were to reload the page.
    //     console.log('AppContext componentDidMount()');

    // }

    componentDidUpdate() {

        // persist context state to session storage.
        // this way, next time we reload page, we can hydrate context state from session storage.
        this.props.saveToSessionStorage("contextState", this.state);
    }

    syncFunc = (authObj) => {


        // grab the IDs from the Auth object and sync it with state
        try {
            const { idToken, accessToken, expiresAt, profile } = authObj;
            this.setState({
                idToken, accessToken, expiresAt, profile
            });

        } catch (e) {
            console.log('error in syncing auth state: ', e);
        }
    }

    render() {
        return (
            // pass down the value to whatever is wrapped by this provider
            // provider is where data lives

            <React.Fragment>
                {this.state.loading > 0 && <Loading />}



                <AppContext.Provider

                    value={{
                        auth: this.auth,
                        state: this.state,
                        setState: (newState, callback) => {

                            // this.props.saveToSessionStorage("contextState", {
                            //     ...this.state,
                            //     ...newState
                            // });

                            if (callback) {
                                this.setState(
                                    {
                                        ...newState
                                    },
                                    callback
                                );
                            } else {
                                this.setState({
                                    ...newState
                                });
                            }
                        },

                        setLanguage: (language) => {
                            this.setState({ uiLanguage: language });
                            //console.log("set!")
                        },

                        handleToggleMenu: () => {
                            if (this.state.isNavBarVisible === undefined) {
                                this.setState({ isNavBarVisible: true });
                            } else {
                                this.setState({
                                    isNavBarVisible: !this.state.isNavBarVisible
                                });
                            }
                        },

                        markLoading: () => {
                            this.setState(function (prevState) {
                                return {
                                    loading: prevState.loading + 1
                                };
                            });
                        },

                        unmarkLoading: () => {
                            this.setState(function (prevState) {

                                // don't let the "loading" count go under 0
                                return {
                                    loading: Math.max(prevState.loading - 1, 0)
                                };
                            });
                        },

                        resetState: (callback) => {
                            this.props.resetSessionStorage();
                            if (callback) {

                                this.setState(
                                    this.initialState,
                                    callback
                                );
                            } else {
                                this.setState(this.initialState);
                            }

                        },

                        // reset just the state that we normally preserve on logouts
                        resetPreservedState: (callback) => {

                            const { selectedFilterDate,
                                selectedFilterOrg,
                                selectedFilterReportGroup,
                                selectedFilterType,
                                selectedFilterVendor,
                                selectedReportStartDate,
                                selectedReportEndDate,
                                selectedReportOrg,
                                selectedReportOrgType,
                                selectedReportReportGroup,
                                selectedReportVendor,
                                selectedReportPartGroup,
                                selectedReportPartCategory,
                                selectedReportMinCost, 
                                selectedReportMaxCost, 
                                selectedReportMinValue, 
                                selectedReportMaxValue,
                                selectedReportAge,
                                email,
                                uiLanguage } = this.initialState;

                            this.setState({
                                selectedFilterDate,
                                selectedFilterOrg,
                                selectedFilterReportGroup,
                                selectedFilterType,
                                selectedFilterVendor,
                                selectedReportStartDate,
                                selectedReportEndDate,
                                selectedReportOrg,
                                selectedReportOrgType,
                                selectedReportReportGroup,
                                selectedReportVendor,
                                selectedReportPartGroup,
                                selectedReportPartCategory,
                                selectedReportMinCost, 
                                selectedReportMaxCost, 
                                selectedReportMinValue, 
                                selectedReportMaxValue,
                                selectedReportAge,
                                email,
                                uiLanguage
                            }, callback ? callback : null);
                        },

                        // log the user out of the system.
                        // reset all properties of the state, but preserve some selected properties
                        logout: () => {

                            this.props.resetSessionStorage();

                            // even though we're logging out, there are some properties we want to preserve for the next time the user logs in
                            const { selectedFilterDate,
                                selectedFilterOrg,
                                selectedFilterReportGroup,
                                selectedFilterType,
                                //selectedFilterVendor,
                                selectedReportStartDate,
                                selectedReportEndDate,
                                selectedReportOrg,
                                selectedReportOrgType,
                                selectedReportReportGroup,
                                selectedReportVendor,
                                selectedReportPartGroup,
                                selectedReportPartCategory,
                                selectedReportMinCost, 
                                selectedReportMaxCost, 
                                selectedReportMinValue, 
                                selectedReportMaxValue,
                                selectedReportAge,
                                email,
                                orgID,
                                uiLanguage } = this.state;

                            // we're using deepClone() here in case this.initialState was initially passed by reference to this.state
                            this.setState({ ...deepClone(this.initialState), selectedFilterDate, selectedFilterOrg, selectedFilterReportGroup, selectedFilterType, selectedReportStartDate, selectedReportEndDate, selectedReportOrg, selectedReportOrgType, selectedReportReportGroup, selectedReportVendor, selectedReportPartGroup, selectedReportPartCategory, selectedReportMinCost, selectedReportMaxCost, selectedReportMinValue, selectedReportMaxValue, selectedReportAge, email, orgID, uiLanguage }, () => {
                                //debugger;
                                this.auth.logout();
                            });



                        }
                    }}
                >

                    {this.props.children}
                </AppContext.Provider>
            </React.Fragment>
        );
    }
}

export default hasStorage(AppContextProvider);



// WEBPACK FOOTER //
// ./src/context/AppContext.js